import React from 'react';
import assign from 'lodash/assign';

export default class CancelledStatus extends React.Component {
  render() {
    const baseStyle = { fontFamily: 'Arial', fontSize: 14 };
    const combinedStyle = this.props.style ? assign(baseStyle, this.props.style) : baseStyle; 
    return (
      <div
        className="d-flex mb-2 alert alert-danger"
        style={combinedStyle}
      >
        This subscription is cancelled
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CancelledStatus.js